<div class="app-layout">
  @if (!isSignedIn()) {
    <div class="app-layout fx-display-grid fx-justify-center fx-items-center">
      <amplify-authenticator [services]="services(this)" initialState="signIn" [hideSignUp]="true" [formFields]="formFields">
        <ng-template amplifySlot="sign-in-header">
          <h2 class="amplify-heading" style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl); font-size: medium; font-weight: bold" i18n>Welcome, please sign in your account</h2>
        </ng-template>
      </amplify-authenticator>
    </div>
  } @else {
    <nz-layout class="app-layout">
      <nz-sider class="menu-sidebar" nzCollapsible [nzCollapsedWidth]="0" nzWidth="250px" nzBreakpoint="lg" [nzCollapsed]="isMenuCollapse()" [nzTrigger]="null">
        <div class="sidebar-logo">
          <a routerLink="/welcome">
            <img class="logo" src="assets/icons/icon-72x72.png" alt="logo" />
            <h1>EI configuration</h1>
          </a>
        </div>
        <ul nz-menu nzTheme="dark" nzMode="inline">
          <li nz-submenu nzOpen nzTitle="Home" i18n-nzTitle nzIcon="home">
            <ul>
              <li nz-menu-item nzMatchRouter>
                <a (click)="redirectTo($event, '/welcome')" routerLink="/welcome" i18n>Welcome</a>
              </li>
              @if (hasOrganizationsMenu()) {
                <li nz-menu-item nzMatchRouter>
                  <a (click)="redirectTo($event, '/organizations')" routerLink="/organizations" i18n>Entities</a>
                </li>
              }
              @if (hasInvestmentProjectsMenu()) {
                <li nz-menu-item nzMatchRouter>
                  <a (click)="redirectTo($event, '/investment-projects')" routerLink="/investment-projects" i18n>Investment Projects</a>
                </li>
              }
              @if (hasDomainValuesMenu()) {
                <li nz-menu-item nzMatchRouter>
                  <a (click)="redirectTo($event, '/domain-values')" routerLink="/domain-values" i18n>Domain Values</a>
                </li>
              }
              @if (hasPermissionsMenu()) {
                <li nz-menu-item nzMatchRouter>
                  <a (click)="redirectTo($event, '/permissions')" routerLink="/permissions" i18n>Permissions</a>
                </li>
              }
            </ul>
          </li>
          <li nz-menu-item (click)="signOut()"><i class="mr-05" nz-icon nzType="logout"></i><span i18n>Sign out</span></li>
        </ul>
      </nz-sider>
      <nz-layout [ngClass]="isMenuCollapse() ? 'menu-collapsed' : 'menu-open'">
        <nz-header class="main-header">
          <div class="pl-05 fx-row fx-gap-1-rem fx-justify-start fx-items-center pr-1-lt-sm pr-15-gt-xs">
            <span class="header-trigger" (click)="toggleCollapse()">
              <i class="trigger" nz-icon [nzType]="true ? 'menu-unfold' : 'menu-fold'"></i>
              &nbsp;&nbsp;
            </span>
            <span class="fxFlex"></span>
            <div class="fx-row fx-gap-1-rem fx-justify-start fx-items-center">
              <div class="fx-hide-xs" style="color: white">{{ userEmail }}</div>
              <div>
                <nz-radio-group [nzName]="'controlSize'" [nzSize]="'small'" [(ngModel)]="locale" (ngModelChange)="switchLanguage()">
                  <label nz-radio-button nzValue="fr"><span>fr</span></label>
                  <label nz-radio-button nzValue="en"><span>en</span></label>
                  <label nz-radio-button nzValue="es"><span>es</span></label>
                </nz-radio-group>
              </div>
            </div>
          </div>
        </nz-header>
        <nz-content id="inner-content">
          <div class="inner-content">
            <router-outlet></router-outlet>
          </div>
        </nz-content>
      </nz-layout>
    </nz-layout>
  }
</div>
